var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorityNormalBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.2L14.6 10.6L16 12L8 20L0 12L1.4 10.6L7 16.2V0H9V16.2Z",
    fill: "#0F1621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityNormalBlack);
export default __webpack_public_path__ + "static/media/priority-normal-black.1cb3fb9848c0332be7832856fffd2eed.svg";
export { ForwardRef as ReactComponent };